import React from 'react';
import Label from '../bootstrap/forms/Label';
import Icon from '../icon/Icon';
import { Container, Row, Col, Spinner } from 'react-bootstrap';


export default function SingleAttahcement({ src, index, name, deleteImage, children }) {
	return (
		<Col className='shadow rounded' onClick={() => {
			window.open(src, '_blank');
		}} key={index} xs={12} sm={6} md={4} lg={3} xl={2} style={{ height: "250px" }}>

			<div

				style={{
					position: 'relative',
					height: '80%',
				}}>
				{children}
			</div>

			<div
				className='d-flex align-items-center justify-content-between px-3 border-top'
				style={{ height: '20%' }}>
				<Label
					className='cursor-pointer'

					style={{
						overflow: 'hidden',
						textOverflow: 'ellipsis',
						whiteSpace: 'nowrap',
						width: '80%',
					}}>
					{name}
				</Label>
				<Icon
					size={'3x'}
					icon='OpenInNew'
					color='info'
					onClick={() => window.open(src, '_blank')}></Icon>
			</div>

		</Col >
	);
}
